import getAuthFormBySlug from './getAuthFormBySlug';

const AuthFormsRequests = { getAuthFormBySlug };

export default AuthFormsRequests;
